import { render, staticRenderFns } from "./KegelProgrammItem.vue?vue&type=template&id=1ea5e79f&"
import script from "./KegelProgrammItem.vue?vue&type=script&lang=js&"
export * from "./KegelProgrammItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports